import Request from "../lib/request";
import {
  ACCEPT_API,
  ARCHIVE_API,
  INVITATION_API,
  PROJECT_TYPES_API,
  PROJECTS_API,
  REJECT_API
} from "../constants/api";

const baseUrl = process.env.REACT_APP_API_URL;

export const list = filter => {
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECTS_API}`,
    needToken: true,
    params: filter ? { ...filter } : {}
  });
};

export const store = data => {
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECTS_API}`,
    needToken: true,
    data: data
  });
};

export const _delete = id => {
  return Request({
    method: "delete",
    url: `${baseUrl}/${PROJECTS_API}/${id}`,
    needToken: true
  });
};

export const edit = (data, projectId) => {
  return Request({
    method: "put",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}`,
    needToken: true,
    data
  });
};

export const accept = projectId => {
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${INVITATION_API}/${ACCEPT_API}`,
    needToken: true
  });
};

export const reject = projectId => {
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${INVITATION_API}/${REJECT_API}`,
    needToken: true
  });
};

export const archive = (id, data) => {
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECTS_API}/${id}/${ARCHIVE_API}`,
    needToken: true,
    data: data
  });
};

export const getProjectType = () => {
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECT_TYPES_API}`,
    needToken: true
  });
};
